import day from 'utils/day';

export const weeklyHours = {
  Sunday: [
    {
      id: 150,
      day: 'Sunday',
      startTime: '12:00am',
      endTime: '11:59pm',
      raw: '12:00am-11:59pm',
      createdAt: '2021-04-28T12:11:38.195Z',
      updatedAt: '2021-04-28T12:11:38.195Z',
      providerId: 92,
      createdBy: 805,
      updatedBy: 805,
    },
  ],
  Monday: [
    {
      id: 2598,
      day: 'Monday',
      startTime: '12:00am',
      endTime: '11:59pm',
      raw: '12:00am-11:59pm',
      createdAt: '2022-01-12T07:23:03.835Z',
      updatedAt: '2022-01-12T07:23:03.835Z',
      providerId: 92,
      createdBy: 805,
      updatedBy: 805,
    },
    {
      id: 2979,
      day: 'Monday',
      startTime: '01:00pm',
      endTime: '05:00pm',
      raw: '01:00pm-05:00pm',
      createdAt: '2022-05-25T14:32:15.928Z',
      updatedAt: '2022-05-25T14:32:15.928Z',
      providerId: 92,
      createdBy: 138,
      updatedBy: 138,
    },
  ],
  Tuesday: [
    {
      id: 1310,
      day: 'Tuesday',
      startTime: '12:00am',
      endTime: '11:59pm',
      raw: '12:00am-11:59pm',
      createdAt: '2021-10-01T02:31:06.491Z',
      updatedAt: '2021-10-01T02:31:06.491Z',
      providerId: 92,
      createdBy: 805,
      updatedBy: 805,
    },
    {
      id: 2986,
      day: 'Tuesday',
      startTime: '12:00am',
      endTime: '01:00am',
      raw: '12:00am-01:00am',
      createdAt: '2022-06-08T11:28:09.051Z',
      updatedAt: '2022-06-08T11:28:09.051Z',
      providerId: 92,
      createdBy: 138,
      updatedBy: 138,
    },
    {
      id: 2983,
      day: 'Tuesday',
      startTime: '12:00am',
      endTime: '02:00pm',
      raw: '12:00am-02:00pm',
      createdAt: '2022-06-03T09:23:15.962Z',
      updatedAt: '2022-06-03T09:23:15.962Z',
      providerId: 92,
      createdBy: 138,
      updatedBy: 138,
    },
  ],
  Wednesday: [
    {
      id: 128,
      day: 'Wednesday',
      startTime: '12:00am',
      endTime: '11:59pm',
      raw: '12:00am-11:59pm',
      createdAt: '2021-04-22T09:15:57.471Z',
      updatedAt: '2021-04-22T09:15:57.471Z',
      providerId: 119,
      createdBy: 805,
      updatedBy: 805,
    },
  ],
  Thursday: [
    {
      id: 129,
      day: 'Thursday',
      startTime: '12:00am',
      endTime: '11:59pm',
      raw: '12:00am-11:59pm',
      createdAt: '2021-04-22T09:15:59.732Z',
      updatedAt: '2021-04-22T09:15:59.732Z',
      providerId: 92,
      createdBy: 805,
      updatedBy: 805,
    },
  ],
  Friday: [
    {
      id: 130,
      day: 'Friday',
      startTime: '12:00am',
      endTime: '11:59pm',
      raw: '12:00am-11:59pm',
      createdAt: '2021-04-22T09:16:02.220Z',
      updatedAt: '2021-04-22T09:16:02.220Z',
      providerId: 92,
      createdBy: 805,
      updatedBy: 805,
    },
  ],
  Saturday: [
    {
      id: 131,
      day: 'Saturday',
      startTime: '12:00am',
      endTime: '11:59pm',
      raw: '12:00am-11:59pm',
      createdAt: '2021-04-22T09:16:04.916Z',
      updatedAt: '2021-04-22T09:16:04.916Z',
      providerId: 92,
      createdBy: 805,
      updatedBy: 805,
    },
  ],
};

export const dailyHours = {
  '2022-06-07': [
    {
      id: 109,
      day: '2022-06-07',
      startTime: '03:03am',
      endTime: '11:59am',
      raw: '03:03am-11:59am',
      createdAt: '2022-06-08T10:41:34.459Z',
      updatedAt: '2022-06-08T10:41:34.459Z',
      createdBy: 138,
      updatedBy: 138,
      providerId: 92,
    },
  ],
};

export const blockedHours = [
  {
    fullName: 'Alice in Chains',
    color: '#797d82',
    endTime: day().tz('UTC').add(5, 'minutes'),
    end: day().tz('UTC').add(5, 'minutes'),
    id: 3,
    notes: null,
    reason: 'Test reason',
    resourceId: 92,
    startTime: day().tz('UTC').add(1, 'minutes'),
    start: day().tz('UTC').add(1, 'minutes'),
    title: 'Test reason',
  },
];
